export enum TypeNature {
    ORGANOLEPTIQUE = 'ORGANOLEPTIQUE'
}
